import { render, staticRenderFns } from "./panel-left.vue?vue&type=template&id=bd9617a4&"
import script from "./panel-left.vue?vue&type=script&lang=js&"
export * from "./panel-left.vue?vue&type=script&lang=js&"
import style0 from "./panel-left.vue?vue&type=style&index=0&id=bd9617a4&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports